import { EMPTY } from 'rxjs';

import { ModalService } from 'ui-components/services/modal-service';

import { FeatureFlags } from '../../feature-flags/feature-flags';
import { FeatureFlagDeclarations } from '../../feature-flags/feature-flag-declarations';
import { UserSettings } from '../../enums/user-settings/user-settings';
import { PostLabelReminderModal } from '../../orders/order-details/fulfillment-plan/sections/customs-documents/post-label-reminder-modal';
import Global from '../global-selectors';

/**
 * After a label is purchased, show a reminder modal when the user previously
 * checked "I'll upload custom documents after label purchase".
 *
 * Call this directly from the label purchase success handler.
 * Uses ModalService to launch the modal directly from the epic (no Redux roundtrip).
 *
 * @param fulfillmentPlanId - The fulfillment plan that just had a label created
 * @param state - Current Redux state snapshot
 * @returns EMPTY (modal is launched as a side-effect)
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const showPostLabelReminderIfNeeded = (fulfillmentPlanId: string, state: any) => {
  const isEnabled = new FeatureFlags({ state }).getFeatureFlag(FeatureFlagDeclarations.isDocumentUploadEnabled);
  if (!isEnabled) return EMPTY;

  const customs = Global.selectCSWCustoms(state, { fulfillmentPlanId });
  if (!customs?.pendingDocuments) return EMPTY;

  const isDismissed = Global.selectUserUserSetting(state, {
    userSetting: UserSettings.customsDocumentReminderDismissed.settingName,
  });
  if (isDismissed) return EMPTY;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (ModalService as any).launchModal({
    component: PostLabelReminderModal,
    props: { fulfillmentPlanId },
  });

  return EMPTY;
};
